import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ManualPaymentService } from 'src/app/services/core/manual-payment/manual-payment.service';
import { sweetAlert } from 'src/app/utils/swal';

@Component({
  selector: 'app-manual-payment-modal',
  templateUrl: './manual-payment-modal.component.html',
  styleUrls: ['./manual-payment-modal.component.css']
})
export class ManualPaymentModalComponent implements OnInit {
  @Input() trip: any;
  @Input() relation: any;
  @Output() closeModal = new EventEmitter<any>();
  manualPaymentForm!: FormGroup;
  submitted = false;

  constructor(
    private fb: FormBuilder,
    private manualPaymentService: ManualPaymentService
  ) { }

  get form() {
    return this.manualPaymentForm.controls;
  }

  ngOnInit() {
    this.manualPaymentForm = this.fb.group({
      transaction_no: ['', Validators.required],
      paymentType: ['', Validators.required],
      notes: ['']
    });
  }

  onSave() {
    this.submitted = true;
    if (this.manualPaymentForm.invalid) {
      return;
    }
    const payload = {
      ...this.manualPaymentForm.value,
      relation: this.relation
    };
    this.manualPaymentService.create(payload).subscribe({
      next: (data: any) => {
        sweetAlert('Success', 'Payment added successfully', 'success', 'OK');
        this.closeModal.emit(data);
      },
      error: (error: any) => {
        sweetAlert('Error', error, 'error', 'OK');
      }
    });
  }

  onCloseModal() {
    this.closeModal.emit();
  }
}
